/**
 * Pantalla de pago aprobado como "ruta" del iframe. Al aprobarse el pago el iframe navega a
 * `/?og=<orderId>#/checkout-app/orderPlaced`; la app (RN) detecta esa URL en el WebView
 * (`isOrderPlacedUrl` + `extractOrderId` en carrefour-checkout) y avanza a PaymentSuccess.
 * El iframe no envía el resultado por postMessage.
 */
const ORDER_PLACED_HASH = '#/checkout-app/orderPlaced';

export const buildOrderPlacedUrl = (currentUrl: string, orderId: string): string => {
  const url = new URL(currentUrl);
  url.search = `?og=${encodeURIComponent(orderId)}`;
  url.hash = ORDER_PLACED_HASH;
  return url.toString();
};

export const readOrderPlaced = (location: Pick<Location, 'search' | 'hash'>): { orderId: string } | undefined => {
  if (location.hash !== ORDER_PLACED_HASH) {
    return undefined;
  }
  const orderId = new URLSearchParams(location.search).get('og');
  return orderId ? { orderId } : undefined;
};

export const redirectToOrderPlaced = (orderId: string): void => {
  window.location.assign(buildOrderPlacedUrl(window.location.href, orderId));
};
